import StorageLogger from "@/modules/common/utils/storageLogger";

const LOCAL_ACCESS_NAME = "access_token";
const LOCAL_REFRESH_NAME = "refresh_token";
const LOCAL_ACCESS_EXP = "access_token_exp";

function setAccessToken(access_token: string) {
  StorageLogger.setItem(LOCAL_ACCESS_NAME, access_token);
}

function setAccessTokenExp(exp: number) {
  StorageLogger.setItem(LOCAL_ACCESS_EXP, exp.toString());
}

function setRefreshToken(refresh_token: string) {
  StorageLogger.setItem(LOCAL_REFRESH_NAME, refresh_token);
}

function cleanTokensData() {
  StorageLogger.removeItem(LOCAL_ACCESS_NAME);
  StorageLogger.removeItem(LOCAL_REFRESH_NAME);
}

function getAccessToken() {
  return StorageLogger.getItem(LOCAL_ACCESS_NAME);
}

function getRefreshToken() {
  return StorageLogger.getItem(LOCAL_REFRESH_NAME);
}

function getAccessTokenExp() {
  const item = StorageLogger.getItem(LOCAL_ACCESS_EXP);
  return item ? parseInt(item, 10) : null;
}

function getJWTPayload(token: string) {
  return parseJWT(token).payload;
}

function parseJWT(token: string) {
  const parts: string[] = token.split(".");

  return {
    header: parsePart(parts[0]),
    payload: parsePart(parts[1]),
    sign: parts[2],
  };
}

function parsePart(str: string) {
  return JSON.parse(window.atob(str));
}

export {
  setAccessToken,
  setRefreshToken,
  setAccessTokenExp,
  cleanTokensData,
  getJWTPayload,
  getAccessToken,
  getRefreshToken,
  getAccessTokenExp,
};
